const { StreetAddressTypeID, BillingAddressTypeID } = window['runConfig'];

export default {

    GetClient(firstName, lastName, email, street1, stree2, city, state, postCode, country, mobilePhone, shipping_address1, shipping_address2, shipping_city, shipping_state,
        shipping_zip, shipping_country, shipping_phone_number) {

        var client = [
            {
                "CustomerType": "Individual",
                "FirstName": firstName,
                "LastName": lastName,
                "CreatedAsGuest": true,
                "GuestEmail": email,
                "DateOfBirth": "",
                "CustomerAddress": [
                    {
                        "IsPrimaryAddress": true,
                        "AddressTypeID": StreetAddressTypeID,
                        "Email": email,
                        "Street1": street1,
                        "Street2": stree2,
                        "CitySuburb": city,
                        "State": state,
                        "Postcode": postCode,
                        "Country": country,
                        "MobilePhone": mobilePhone
                    },
                    {
                        "IsPrimaryAddress": false,
                        "AddressTypeID": BillingAddressTypeID,
                        "Email": email,
                        "Street1": shipping_address1,
                        "Street2": shipping_address2,
                        "CitySuburb": shipping_city,
                        "State": shipping_state,
                        "Postcode": shipping_zip,
                        "Country": shipping_country,
                        "MobilePhone": shipping_phone_number
                    }
                ],
                "LinkedIndividuals": []
            }
        ]

        return client;
    }
}